module.exports = __webpack_public_path__ + "static/media/IN.755cde91.svg";